"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadExcludedPagesForSitemap = exports.FetchExcludedPagesForSitemap = exports.FetchExcludedPagesForSitemapActionTypes = exports.loadIncludedPagesForSitemap = exports.FetchIncludedPagesForSitemap = exports.FetchIncludedPagesForSitemapActionTypes = exports.PagesForSitemapsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var PagesForSitemapsActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_INCLUDED_PAGES_FOR_SITE_MAP: null,
  FETCH_INCLUDED_PAGES_FOR_SITE_MAP: null,
  LOAD_EXCLUDED_PAGES_FOR_SITE_MAP: null,
  FETCH_EXCLUDED_PAGES_FOR_SITE_MAP: null
}, 'pagesForSitemaps');
exports.PagesForSitemapsActionTypes = PagesForSitemapsActionTypes;
var FetchIncludedPagesForSitemapActionTypes = (0, _actions.createRequestTypes)(PagesForSitemapsActionTypes.FETCH_INCLUDED_PAGES_FOR_SITE_MAP);
exports.FetchIncludedPagesForSitemapActionTypes = FetchIncludedPagesForSitemapActionTypes;
var FetchIncludedPagesForSitemap = (0, _actions.createRequestActions)(FetchIncludedPagesForSitemapActionTypes, {
  keys: ['domain']
});
exports.FetchIncludedPagesForSitemap = FetchIncludedPagesForSitemap;
var loadIncludedPagesForSitemap = (0, _fluxActions.createAction)(PagesForSitemapsActionTypes.LOAD_INCLUDED_PAGES_FOR_SITE_MAP, (0, _actions.mapPayloadTo)('domain'));
exports.loadIncludedPagesForSitemap = loadIncludedPagesForSitemap;
var FetchExcludedPagesForSitemapActionTypes = (0, _actions.createRequestTypes)(PagesForSitemapsActionTypes.FETCH_EXCLUDED_PAGES_FOR_SITE_MAP);
exports.FetchExcludedPagesForSitemapActionTypes = FetchExcludedPagesForSitemapActionTypes;
var FetchExcludedPagesForSitemap = (0, _actions.createRequestActions)(FetchExcludedPagesForSitemapActionTypes, {
  keys: ['domain']
});
exports.FetchExcludedPagesForSitemap = FetchExcludedPagesForSitemap;
var loadExcludedPagesForSitemap = (0, _fluxActions.createAction)(PagesForSitemapsActionTypes.LOAD_EXCLUDED_PAGES_FOR_SITE_MAP, (0, _actions.mapPayloadTo)('domain'));
exports.loadExcludedPagesForSitemap = loadExcludedPagesForSitemap;